/**
 * Os vossos favoritos: separadores e setas do carrossel.
 *
 * As setas empurram a pista do separador que está aberto. A pista desloca-se
 * de forma nativa — com o dedo, com a barra, com o teclado — e estas setas são
 * só mais uma maneira de lá chegar, não a única.
 */
class ClaroFavoritos extends HTMLElement {
  #abas = [];
  #paineis = [];

  connectedCallback() {
    this.#abas = [...this.querySelectorAll('[data-claro-aba]')];
    this.#paineis = [...this.querySelectorAll('[data-claro-painel-aba]')];

    this.#abas.forEach((aba) =>
      aba.addEventListener('click', () => this.#abre(aba.dataset.claroAba))
    );

    this.querySelectorAll('[data-claro-anda]').forEach((seta) =>
      seta.addEventListener('click', () => this.#anda(Number(seta.dataset.claroAnda)))
    );

    // Uma pista curta não precisa de setas: escondem-se em vez de ficarem mortas
    this.#pistas().forEach((pista) => pista.addEventListener('scroll', () => this.#pinta(), { passive: true }));
    addEventListener('resize', () => this.#pinta());
    this.#pinta();
  }

  #pistas() {
    return [...this.querySelectorAll('[data-claro-pista]')];
  }

  /** A pista do separador aberto, que é a única visível */
  #pista() {
    return this.#pistas().find((p) => !p.closest('[data-claro-painel-aba]').hidden);
  }

  #abre(indice) {
    this.#abas.forEach((aba) =>
      aba.setAttribute('aria-selected', String(aba.dataset.claroAba === indice))
    );
    this.#paineis.forEach((painel) => {
      painel.hidden = painel.dataset.claroPainelAba !== indice;
    });
    this.#pinta();
  }

  #anda(sentido) {
    const pista = this.#pista();
    if (!pista) return;

    // Um cartão e o intervalo até ao seguinte: assim para sempre alinhado
    const cartao = pista.querySelector('.claro-card');
    const passo = cartao ? cartao.getBoundingClientRect().width + 16 : pista.clientWidth;
    pista.scrollBy({ left: passo * sentido * 2, behavior: 'smooth' });
  }

  #pinta() {
    const pista = this.#pista();
    const setas = [...this.querySelectorAll('[data-claro-anda]')];
    if (!pista) return;

    const sobra = pista.scrollWidth - pista.clientWidth;
    const caixa = this.querySelector('.claro-setas');

    // Sem nada para deslizar, as setas não têm razão de existir
    if (caixa) caixa.hidden = sobra < 8;

    setas.forEach((seta) => {
      const paraTras = Number(seta.dataset.claroAnda) < 0;
      seta.disabled = paraTras ? pista.scrollLeft < 8 : pista.scrollLeft >= sobra - 8;
    });
  }
}

if (!customElements.get('claro-favoritos')) customElements.define('claro-favoritos', ClaroFavoritos);
